import React from 'react';
import { timeHelper } from '../../core/helpers/timeHelper';
import { TranslationKeys } from '../../core/constants/translationKeys';

function FairnessInfo({ roundId, time, t }) {
  return (
    <div className='cpt-cof-title-block'>
      <p className='cpt-round-title'>
        {t(TranslationKeys.RoundId)} {roundId}
      </p>
      <p className='cpt-round-title-data-time'>
        <span className='cpt-round-data'> {timeHelper(time)}</span>
        {/* <span className='cpt-round-time'> 12:07:27</span> */}
      </p>
    </div>
  );
}
export default FairnessInfo;
